import { useEffect } from 'react';
import { useUnit } from 'effector-react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { PayinTicketStatus } from '~/entities/payin';
import { queryKeys } from '~/shared/api/queryKeys';
import {
    adminPayoutTicketServiceCountTickets,
    getAdminPayoutTicketServiceCountTicketsUrl,
} from '~/generated/payoutBackend/ticket';
import { type AdminPayoutTicketServiceCountTicketsFilterStatusesItem } from '~/generated/payoutBackend/model';
import { $newTicketsCount, setNewTicketsCount } from '../model';
import { notifyOfNewTicket } from './helper';

export const useWatchNewTickets = () => {
    const queryClient = useQueryClient();
    const { previousCount, updateCount } = useUnit({
        previousCount: $newTicketsCount,
        updateCount: setNewTicketsCount,
    });
    const res = useQuery({
        refetchInterval: 5000,
        refetchOnWindowFocus: true,
        queryFn: () =>
            adminPayoutTicketServiceCountTickets({
                'filter.statuses': [
                    PayinTicketStatus.STATUS_CREATED,
                ] as unknown as AdminPayoutTicketServiceCountTicketsFilterStatusesItem[],
            }),
        queryKey: [
            queryKeys.PAYOUT_TICKETS,
            getAdminPayoutTicketServiceCountTicketsUrl({
                'filter.statuses': [
                    PayinTicketStatus.STATUS_CREATED,
                ] as unknown as AdminPayoutTicketServiceCountTicketsFilterStatusesItem[],
            }),
        ],
    });

    useEffect(() => {
        const total = Number(res.data?.count);

        if (!Number.isFinite(total)) {
            return;
        }

        if (previousCount !== total) {
            if (total > 0 && (previousCount === null || total > previousCount)) {
                notifyOfNewTicket();
                queryClient.invalidateQueries({ queryKey: [queryKeys.PAYIN_TICKETS] });
            }

            updateCount(total);
        }
    }, [previousCount, queryClient, res.data?.count, updateCount]);
};
